import { render } from "./index.vue?vue&type=template&id=6ab0acbc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-support-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ab0acbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ab0acbc', __exports__)) {
    api.reload('6ab0acbc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6ab0acbc", () => {
    api.rerender('6ab0acbc', render)
  })

}


export default __exports__